module.exports = __webpack_public_path__ + "img/tmr.8004d17b.jpeg";